export default __webpack_public_path__ + "static/media/pantalon-rockero-mujer.e2720ad4.png";